export function ExportPillGroup<T extends string>({
  options,
  selected,
  name,
  labelId,
  onSelect,
}: {
  options: { value: T; label: string }[];
  selected: T;
  name: string;
  labelId: string;
  onSelect: (value: T) => void;
}) {
  return (
    <div className="ecp-pill-group" role="radiogroup" aria-labelledby={labelId}>
      {options.map(({ value, label }) => (
        <label
          key={value}
          htmlFor={`${name}-${value}`}
          className={`ecp-pill${selected === value ? " ecp-pill--selected" : ""}`}
        >
          <input
            type="radio"
            id={`${name}-${value}`}
            name={name}
            value={value}
            checked={selected === value}
            onChange={() => onSelect(value)}
            className="ecp-pill-input"
          />
          <span className="ecp-pill-radio" aria-hidden="true">
            <span className="ecp-pill-radio-dot" />
          </span>
          {label}
        </label>
      ))}
    </div>
  );
}
